export default {
    global: {
        home: 'Home',
        back: 'Back',
        close: 'Close',
        password: 'Password',
        email: 'E-mail',
        name: 'Name',
        passwordVerify: 'Password (verify)',
        logout: 'Sign out',
        other: 'other',
        selectAll: 'Select all',
        removeAll: 'Remove all',
    },

    home: {
        info: 'Software for gathering and analyzing user opinions of a selected product segment. Source data is obtained from various publicly accessible websites containing opinions of ordinary users and experts in the segment of digital cameras, mobile phones, etc'
    },

    //prohlizeni produktu
    products: {
        products: 'Categories',
        stats: 'Statistics',
    },
    product: {
        back: 'Back to category',
        alternativeNames: 'Alternative names',
        introduced: 'Introduced in',
        reviewCount: 'Reviews',
        ourScore: 'Our score',
        ofReviews: 'from {num} reviews',
        notCalculated: 'impossible to calculate',
        notCalculatedYet: 'not calculated yet',
        makeFavourite: 'Make favourite',
        removeFavourite: 'Remove from favourites',
        rating: 'Product rating',
        overview: 'Overview',
        charts: 'Charts',
        parameters: 'Parameters',
        overallOpinion: 'Overall opinion',
        ratingsOverTime: 'Reviews over time',
        addReview: 'Write my review',
        modifyReview: 'Modify my review',
        compare: 'Compare',
        compareRemove: 'Remove from comparison',
        ratingOnComments: 'Rating X amount of comments',
        similar: 'Similar products',
        similarInfo: 'We can find similar products based on user reviews in given span of years.',
        articles: 'Articles',
        readArticle: 'Read article',
        noArticles: 'No articles found',
        frequentKeywords: 'User comments',
    },
    compare: {
        compare: 'Product comparison',
        noProducts: 'There are no selected products to compare.',
        showPlusMinus: 'Show rating counts',
        wins: 'Wins',
        selectedFeatures: 'Selected features',
        allFeatures: 'All features',
        external: 'Products from URL',
        toCompare: 'nothing to compare | {num} product to compare | {num} products to compare',
        addOneMore: 'Add one more product',
    },
    search: {
        search: 'Search',
        searchStart: 'Search',
        results: 'Search results',
        minYear: 'Min year of manufacture',
        maxYear: 'Max year of manufacture',
        category: 'Category',
        sortFeatures: 'Select features for sorting',
        noResults: 'No search results found.',
        query: 'Search query',
    },
    productSort: {
        sort: 'Sort by',
        reviews: 'All reviews',
        reviewsNegative: 'Negative reviews',
        reviewsPositive: 'Positive reviews',
        rating: 'Our score',
        newest: 'Recently added',
        introduced: 'Year introduced',
        trending: 'Recently discussed',
        mostVisited: 'Pageviews',
    },
    featureSort: {
        sort: 'Sort by (wordcloud font size)',
        quantity: 'Overall amount of opinions',
        positive: 'Positive opinions',
        negative: 'Negative opinions',
        undecided: 'Undecided',
        decided: 'Decided',
        heaviest: 'Dominant opinion',
        percent: 'Percentage'
    },
    favourites: {
        favourites: 'Favourite products',
        noProducts: 'You have no favourite products.',
        remove: 'Remove from favourites',
    },
    reviewed: {
        reviewed: 'Reviewed products',
        noProducts: 'You have no reviewed products.'
    },
    stats: {
        stats: 'Statistics for',
        brand: 'Reviews by brand',
        brandInfo: 'Shows share of reviews for given brand on overall amount of reviews in particular month. Hover mouse over data to get brand name.',
        topic: 'Reviews by topic',
        topicInfo: 'Shows share of reviews for given topic in particular month. Hover mouse over data to get topic name.',
        sentiment: 'Reviews by sentiment',
        sentimentInfo: 'Shows absolute amounts of positive and negative reviews in particular month.',
        selectSignificant: 'Select significant'
    },

    //vlastni hodnoceni
    review: {
        review: 'Add or modify custom review',
        thanks: 'Your review will be processed by our algorithms and it will have impact on the overall product rating. Thank you for helping us with product reviews.',
        positives: 'Positives',
        negatives: 'Negatives',
        store: 'Store',
    },

    //ctecka EAN
    barcode: {
        barcode: 'Scan EAN code',
        scan: 'Scan EAN barcode',
    },

    //uzivatelske veci
    login: {
        login: 'Sign in',
        error: 'Error in supplied information.',
    },
    register: {
        register: 'Sign up',
        error: 'Error in supplied information.',
        errorExists: 'Account already exists.',

    },
    profile: {
        profile: 'Profile',
        change: 'Change user info',
        changed: 'Changes saved.',
        change: 'Save',
        changePassword: 'Change password',
        name: 'Name',
    },
    forgottenPassword: {
        forgottenPassword: 'Forgotten password',
        info: 'Insert email address used by your account. We will send you a link to reset your password.',
        send: 'Email send.',
        sendEmail: 'Send email'
    },
    passChange: {
        success: 'Password changed.',
        change: 'Change password',
        oldPass: 'Old password',
        newPass: 'New password',
        newPassVerify: 'Verify new password',
    },
    passReset: {
        passReset: 'Reset password',
        info: 'We will email you a new password after pressing button.',
        sent: 'Password sent.',
        send: 'Send new password'
    },

    //chyby validace
    error: {
        nameRequired: 'Name is required.',
        emailRequired: 'Email is required.',
        emailFromat: 'Email is not in correct format.',
        passwordRequired: 'Password required.',
        passwordMinLength: 'Password has to be at least {len} characters long.',
        accountAlreadyExists: 'This account is already registered.',
        passwordVerified: 'Passwords must match.',
        mustBeYear: 'Manufacture year must be number more than 0 and less than current year.',
        minYearMoreThanMax: 'Max manufacture year must be at least same as min year.',
        oldPassRequired: 'Old password is required.',
        passRequired: 'Password is required.',
        passMinLength: 'Password must have at least {min} characters.',
        passMatch: 'Passwords must match.',
        credentials: 'Error in supplied credentials.',
        passDifferent: 'New password should be different than old one.',
        noParams: 'Sorry, we do not have any parameters for this product.',
        plusAddsValues: 'Add values using plus button.',
        fillReviewOrRemoveFields: 'It is required to fill at least one aspect of review or remove empty fields.',
        noToken: 'Invalid token in URL.',
        tokenNotFound: 'Token not found, password was already sent.',
    }
}
